import React, { useState } from 'react';
import { Link, useLocation, Navigate} from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAuth } from '../contexts/AuthContext';
import AuthLayout from '../components/auth/AuthLayout';

const Login = () => {
  return <Navigate to="/" replace />; // redirect immediately
  const location = useLocation();
  const { login, loading } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors
  } = useForm();

  const onSubmit = async (data) => {
    clearErrors();
    
    const result = await login(data.email, data.password);
    
    if (!result.success) {
      setError('root', {
        type: 'manual',
        message: result.error
      });
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <AuthLayout 
      title="LOGIN" 
      subtitle="Sign in to your PROSKINS account"
    >
      {errors.root && (
        <div className="proskins-alert proskins-alert-error">
          <span>❌</span>
          <div>
            <strong>Login failed</strong>
            <p>{errors.root.message}</p>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit(onSubmit)} className="auth-form">
        <div className="proskins-form-group">
          <label className="proskins-label">Email Address</label>
          <input
            type="email"
            className={`proskins-input ${errors.email ? 'proskins-input-error' : ''}`}
            placeholder="Enter your email"
            {...register('email', {
              required: 'Email is required',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Please enter a valid email address'
              }
            })}
          />
          {errors.email && (
            <div className="proskins-text-accent" style={{ fontSize: 'var(--font-size-xs)', marginTop: 'var(--spacing-xs)' }}>
              {errors.email.message}
            </div>
          )}
        </div>

        <div className="proskins-form-group">
          <label className="proskins-label">Password</label>
          <div className="auth-password-container">
            <input
              type={showPassword ? 'text' : 'password'}
              className={`proskins-input ${errors.password ? 'proskins-input-error' : ''}`}
              placeholder="Enter your password"
              {...register('password', {
                required: 'Password is required',
                minLength: {
                  value: 6,
                  message: 'Password must be at least 6 characters'
                }
              })}
            />
            <button
              type="button"
              className="auth-password-toggle"
              onClick={togglePasswordVisibility}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? '👁️‍🗨️' : '👁️'}
            </button>
          </div>
          {errors.password && (
            <div className="proskins-text-accent" style={{ fontSize: 'var(--font-size-xs)', marginTop: 'var(--spacing-xs)' }}>
              {errors.password.message}
            </div>
          )}
        </div>

        <div className="auth-form-footer">
          <Link to="/forgot-password" className="auth-link">
            Forgot your password?
          </Link>
        </div>

        <button
          type="submit"
          className="proskins-btn proskins-btn-primary proskins-btn-large proskins-btn-full"
          disabled={loading}
        >
          {loading ? (
            <>
              <div className="proskins-loading"></div>
              Signing In...
            </>
          ) : (
            'LOGIN'
          )}
        </button>
      </form>

      <div className="auth-divider">
        <span>or</span>
      </div>

      <div className="auth-text">
        Don't have an account?{' '}
        <Link to="/register" className="auth-link">
          Sign up for free
        </Link>
      </div>
    </AuthLayout>
  );
};

export default Login;